import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import GallectionCover from '../GallectionCover';
const GallectionListItemButton = (_param)=>{
    var { gallection  } = _param, rest = _object_without_properties(_param, [
        "gallection"
    ]);
    return /*#__PURE__*/ React.createElement(ListItemButton, _extends({
        label: gallection.name,
        prefix: /*#__PURE__*/ React.createElement(GallectionCover, {
            gallection: gallection
        }),
        fillContainerWidth: true
    }, rest));
};
GallectionListItemButton.displayName = 'GallectionListItemButton';
export default GallectionListItemButton;
